import { render, staticRenderFns } from "./SubscribeToCampaignWidget.vue?vue&type=template&id=6798b045"
import script from "./SubscribeToCampaignWidget.vue?vue&type=script&lang=js"
export * from "./SubscribeToCampaignWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports